import React, { useEffect, useState } from "react";
import ReactCrop from "react-image-crop";
import { v4 as uuidv4 } from "uuid";
import { UploadImage } from "./imageUpload";
import customToast from "../../components/common/basic/Toast";
import { Modal } from "react-bootstrap";
import "tippy.js/dist/tippy.css";
import "react-image-crop/dist/ReactCrop.css";
import FormButtons from "../Molecule/Buttons/FormButtons";

const CropImageModal = props => {
	const [imageSrc, setImageSrc] = useState("");
	const [imageRef, setImageRef] = useState("");
	const [imageType, setImageType] = useState("");
	const [imagePreviewUrl, setImagePreviewUrl] = useState("");
	const [imageName, setImageName] = useState("");
	const [croppedImageUrl, setCroppedImageUrl] = useState("");
	const [imageCrop, setImageCrop] = useState(() => {
		return props.aspect
			? { unit: "%", width: 100, aspect: 2 / 1 }
			: {
					unit: "%",
					width: 100,
					// height: 50,
					aspect: 1 / 1
				};
	});

	/*make use of load to disable the button once submit is clicked see line no. 105*/
	const [load, setLoad] = useState(false);
	/*make use of modalClosed to disable the loader once modal has closed see line no. 120 */
	const [modalClosed, setModalClosed] = useState(false);

	useEffect(() => {
		onCropComplete({
			aspect: 1,
			height: imageCrop.height,
			unit: "%",
			width: imageCrop.width,
			x: 0,
			y: 0
		});
	}, [imageRef]);

	const onModalOpen = e => {
		if (props.imageRef.files && props.imageRef.files.length > 0) {
			const reader = new FileReader();
			reader.addEventListener("load", () => {
				setImageType(props.imageRef.files[0].type);
				setImageName(props.imageRef.files[0].name);
				setImageSrc(reader.result);
			});
			reader.readAsDataURL(props.imageRef.files[0]);
		} else {
			setImageSrc("");
			setImageRef("");
			setCroppedImageUrl("");
			setImageName("");
			setImageType("");
			setImageCrop({
				unit: "%",
				width: 40,
				aspect: 1 / 1
			});
		}
	};

	const onCropComplete = async crop => {
		if (imageRef && crop.width && crop.height) getCroppedImg(imageRef, crop, imageName);
	};

	function getCroppedImg(image, crop, fileName) {
		// to upload with better clarity
		const canvas = document.createElement("canvas");
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		var originWidth = crop.width * scaleX;
		var originHeight = crop.height * scaleY;
		// maximum width/height
		var maxWidth = 1350,
			maxHeight = 1350 / (16 / 9);
		var targetWidth = originWidth,
			targetHeight = originHeight;
		if (originWidth > maxWidth || originHeight > maxHeight) {
			if (originWidth / originHeight > maxWidth / maxHeight) {
				targetWidth = maxWidth;
				targetHeight = Math.round(maxWidth * (originHeight / originWidth));
			} else {
				targetHeight = maxHeight;
				targetWidth = Math.round(maxHeight * (originWidth / originHeight));
			}
		}
		// set canvas size
		canvas.width = targetWidth;
		canvas.height = targetHeight;
		const ctx = canvas.getContext("2d");
		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			targetWidth,
			targetHeight
		);
		// As Base64 string
		// const base64Image = canvas.toDataURL('image/jpeg');
		// As a blob
		return new Promise((resolve, reject) => {
			canvas.toBlob(
				blob => {
					if (!blob) {
						//reject(new Error('Canvas is empty'));
						console.error("Canvas is empty");
						return;
					}
					blob.name = fileName;
					window.URL.revokeObjectURL(imagePreviewUrl);
					setCroppedImageUrl(blob);
					setImagePreviewUrl(window.URL.createObjectURL(blob));
					resolve(null);
				},
				"image/png",
				1
			);
		});
	}

	// const getCroppedImg = (image, crop, fileName) => {
	// 	const canvas = document.createElement("canvas");
	// 	const scaleX = image.naturalWidth / image.width;
	// 	const scaleY = image.naturalHeight / image.height;
	// 	canvas.width = crop.width;
	// 	canvas.height = crop.height;
	// 	const ctx = canvas.getContext("2d");

	// 	ctx.drawImage(
	// 		image,
	// 		crop.x * scaleX,
	// 		crop.y * scaleY,
	// 		crop.width * scaleX,
	// 		crop.height * scaleY,
	// 		0,
	// 		0,
	// 		crop.width,
	// 		crop.height
	// 	);

	// 	return new Promise((resolve, reject) => {
	// 		canvas.toBlob(blob => {
	// 			if (!blob) {
	// 				//reject(new Error('Canvas is empty'));
	// 				console.error("Canvas is empty");
	// 				return;
	// 			}
	// 			blob.name = fileName;
	// 			window.URL.revokeObjectURL(imagePreviewUrl);
	// 			setCroppedImageUrl(blob);
	// 			setImagePreviewUrl(window.URL.createObjectURL(blob));
	// 			resolve(null);
	// 		}, "image/png");
	// 	});
	// };

	const uploadImage = async e => {
		if (croppedImageUrl === "") {
			customToast.error("Image upload failed. Please try cropping the image again");
			return;
		}
		try {
			setLoad(true);
			const imageUrl = await UploadImage(
				croppedImageUrl,
				`${Date.now()}-${uuidv4()}.${
					imageName.split(".")[imageName.split(".").length - 1]
				}`,
				props.moduleNo,
				imageType
			);
			props.imageHandlerFunc(imageUrl, imagePreviewUrl);
			setLoad(false);
			props.closeModal();
			setModalClosed(true);
		} catch (err) {
			console.log(err);
		}
	};

	/*Adding this useEffect because after saving, loader would start but just before the modal would close the button would get enabled again for a tad amount of time, */

	return (
		<>
			<Modal
				show={props.show}
				animation={true}
				onShow={onModalOpen}
				keyboard={false}
				className="modal"
				backdrop="static"
			>
				<div className="mx-4 px-2">
					<div className="d-flex justify-content-between pt-4">
						<p className="w-100 formTitle mb-3">Crop Image</p>
						<i
							className="fas fa-times closeIcon"
							onClick={() => props.closeModal()}
						></i>
					</div>
					<ReactCrop
						src={imageSrc}
						imageStyle={{ minWidth: "100px", maxHeight: "340px" }}
						crop={imageCrop}
						onChange={crop => {
							setImageCrop(crop);
						}}
						ruleOfThirds
						onImageLoaded={image => {
							setImageRef(image);
						}}
						onComplete={onCropComplete}
					/>

					<div className="w-100 mb-2">
						<FormButtons
							onSave={e => uploadImage(e)}
							onCancel={() => props.closeModal()}
							saveBtnContent={"Save"}
							cancelBtnDisabled={false}
							isLoading={load}
							saveBtnDisabled={load}
						/>
					</div>
				</div>
			</Modal>
			<style jsx global>{`
				.modal {
					// margin-left: 125px;
					top: 100 !important;
					z-index: 10000;
					display: flex !important;
				}

				.modal-backdrop {
					position: fixed !important;
					top: 100 !important;
					left: 0;
					z-index: 1040;
					width: 100vw;
					height: 100vh;
					background-color: #000;
				}
				.modal-header {
					border-bottom: 0 none;
				}

				.modal-footer {
					border-top: 0 none;
				}
				.custom-save-cancel-uploader {
					width: auto !important;
				}
			`}</style>
		</>
	);
};

export default CropImageModal;
